import { render, staticRenderFns } from "./c-Category.vue?vue&type=template&id=03e270b2&scoped=true&"
import script from "./c-Category.vue?vue&type=script&lang=js&"
export * from "./c-Category.vue?vue&type=script&lang=js&"
import style0 from "./c-Category.vue?vue&type=style&index=0&id=03e270b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e270b2",
  null
  
)

export default component.exports